<template>
  <div class="visualization">
      <v-scale-screen width="1920" height="1080" :fullScreen="true" :delay="500" ref="scaleScreen">
        <div class="bg">
              <dv-loading v-show="loading">Loading...</dv-loading>
              <div class="host-body">
                  <div style="height: 100%">
                      <!-- 顶部title部分 -->
                      <el-row class="topBox">
                          <el-col :span="6">
                              <div style="display: flex;align-items: flex-end;width: 100%;margin-top: 10px">
                                  <div class="goBack" style="margin-top: 5px">
                                      <img src="../../assets/img/goBack.png" alt="" @click="goBcakBtn" style="height: 24px">
                                      <div class="btn-fullscreen" @click="handleFullScreen">
                                          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                                              <i class="el-icon-rank"></i>
                                          </el-tooltip>
                                      </div>
                                  </div>
                                  <div class="title_name">{{allData.com_name}}</div>
                              </div>
                              <dv-decoration-8
                              class="title_right"
                              :color="['#008CFF', '#00ADDD']"
                              ref="topBorder1"
                              :key="`border-top1-${borderKey}`"
                          />
                          </el-col>
                          <el-col :span="12">
                              <div class="title_text">法 律 服 务 生 态 系 统 数 据 中 心</div>
                              <dv-decoration-5
                                  class="title_center"
                                  :color="['#008CFF', '#00ADDD']"
                                  ref="topBorder2"
                                  :key="`border-top2-${borderKey}`"
                              />
                          </el-col>
                          <el-col :span="6">
                              <div class="title_time">{{ dateYear +'&nbsp'+ dateWeek +'&nbsp'+ dateDay }}</div>
                              <dv-decoration-8
                                  :reverse="true"
                                  class="title_left"
                                  :color="['#008CFF', '#00ADDD']"
                                  ref="topBorder3"
                                  :key="`border-top3-${borderKey}`"
                              />
                          </el-col>
                      </el-row>
<!--                      主体部分-->
                      <el-row class="mainBox">
                          <!-- 左侧 -->
                          <el-col :span="6">
                              <dv-border-box-13
                                  ref="leftBorder1"
                                  class="main-left"
                                  :key="`border-left1-${borderKey}`"
                              >
                                  <signNum :allData="allData"></signNum>
                              </dv-border-box-13>
                              <dv-border-box-13
                                  ref="leftBorder2"
                                  class="main-left"
                                  :key="`border-left2-${borderKey}`"
                              >
                                  <signTrend :echartsData="echartsData"></signTrend>
                              </dv-border-box-13>
                              <dv-border-box-13
                                  ref="leftBorder3"
                                  class="main-left"
                                  :key="`border-left3-${borderKey}`"
                              >
                                  <orderStatistics :echartsData="echartsData"></orderStatistics>
                              </dv-border-box-13>
                          </el-col>

                          <!-- 中间 -->
                          <el-col :span="12">
                              <dv-border-box-1
                                  ref="centerBorder"
                                  class="main-center"
                                  :key="`border-center-${borderKey}`"
                              >
                                  <nationalNum :allData="allData"></nationalNum>
                              </dv-border-box-1>
                          </el-col>

                          <!-- 右侧 -->
                          <el-col :span="6">
                              <dv-border-box-13
                                  ref="rightBorder1"
                                  class="main-right"
                                  :key="`border-right1-${borderKey}`"
                              >
                                  <tj_confirmCase :allData="allData"></tj_confirmCase>
                              </dv-border-box-13>
                              <dv-border-box-13
                                  ref="rightBorder2"
                                  class="main-right"
                                  :key="`border-right2-${borderKey}`"
                              >
                                  <tj_caseTrend :echartsData="echartsData"></tj_caseTrend>
                              </dv-border-box-13>
                              <dv-border-box-13
                                  ref="rightBorder3"
                                  class="main-right"
                                  :key="`border-right3-${borderKey}`"
                              >
                                  <productHeat :allData="allData"></productHeat>
                              </dv-border-box-13>
                          </el-col>
                      </el-row>
                  </div>
              </div>
          </div>
      </v-scale-screen>
  </div>
</template>

<script>
// import drawMixin from "../../utils/drawMixin"; //自适应缩放
import { formatTime } from '@/utils';
import signNum from '@/views/visualization/components/signNum.vue';
import signTrend from '@/views/visualization/components/signTrend.vue';
import orderStatistics from '@/views/visualization/components/orderStatistics.vue';
import nationalNum from '@/views/visualization/components/nationalNum.vue';
import tj_confirmCase from '@/views/visualization/components/tj_confirmCase.vue';
import tj_caseTrend from '@/views/visualization/components/tj_caseTrend.vue';
import productHeat from '@/views/visualization/components/productHeat.vue';
import { getEchartsData, getScreenData } from '@/api/largeScreen';
import { debounce } from '@jiaminghi/data-view/lib/util'; //日期格式转换
export default {
  name: 'visualization',
    // mixins: [drawMixin],
    components:{
        signNum,
        signTrend,
        orderStatistics,
        nationalNum,
        tj_confirmCase,
        tj_caseTrend,
        productHeat
    },
    data() {
        return {
            fullscreen: false,
            allData:'',
            echartsData:'',
            //定时器
            timing: null,
            //loading图
            loading: true,
            //时分秒
            dateDay: null,
            //年月日
            dateYear: null,
            //周几
            dateWeek: null,
            //周几
            weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
            borderKey: 0 // 用于强制刷新边框组件
        };
    },

    mounted() {
        //获取实时时间
        this.timeFn();
        this.initBorders();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        //离开时删除计时器
        clearInterval(this.timing);
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initBorders() {
            this.$nextTick(() => {
                // 强制刷新所有边框组件
                this.borderKey += 1;

                // 延迟确保尺寸计算完成
                setTimeout(() => {
                    const borderRefs = [
                        'topBorder1', 'topBorder2', 'topBorder3',
                        'leftBorder1', 'leftBorder2', 'leftBorder3',
                        'rightBorder1', 'rightBorder2', 'rightBorder3',
                        'centerBorder'
                    ];

                    borderRefs.forEach(ref => {
                        if (this.$refs[ref] && this.$refs[ref].initWH) {
                            this.$refs[ref].initWH(true); // 强制重新初始化
                        }
                    });
                }, 300);
            });
        },

        // 处理窗口大小变化
        handleResize: debounce(function() {
            this.initBorders();
            if (this.$refs.scaleScreen && this.$refs.scaleScreen.setScale) {
                this.$refs.scaleScreen.setScale();
            }
        }, 300),
        //右上角当前日期时间显示：每一秒更新一次最新时间
        timeFn() {
            this.timing = setInterval(() => {
                //获取当前时分秒
                this.dateDay = formatTime(new Date(), "HH : mm : ss");
                //获取当前年月日
                this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
                //获取当前周几
                this.dateWeek = this.weekday[new Date().getDay()];
            }, 1000);
        },
        //loading图
        cancelLoading() {
            setTimeout(() => {
                this.loading = false;
                this.initBorders(); // 数据加载完成后重新初始化边框
            }, 500);
        },
        // 返回
        goBcakBtn(){
            this.$router.push({
                path:'/index'
            })
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
    },
    async created() {
        try {
            const request1 = await getScreenData();
            if (request1.code === 200) {
                this.allData = request1.data;
            } else {
                this.$message.error(request1.msg);
            }

            const request2 = await getEchartsData();
            if (request2.code === 200) {
                this.echartsData = request2.data;
            } else {
                this.$message.error(request2.msg);
            }

            // 数据加载完成后进行其他操作
            this.cancelLoading();
        } catch (error) {
            this.$message.error("数据获取失败");
        }
    }
}

</script>

<style scoped lang="scss">
.visualization{
    width: 100%;
    height: 100vh;
    overflow: hidden;

}
//全局样式部分！！！！
* {
    margin: 0;
    padding: 0;
    list-style-type: none;
    outline: none;
    box-sizing: border-box;
}
html {
    margin: 0;
    padding: 0;
}
body {
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.2em;
    background-color: #f1f1f1;
    margin: 0;
    padding: 0;
}
a {
    color: #343440;
    text-decoration: none;
}
//--------------------------------------------

//页面样式部分！！！！
//#index {
//    color: #d3d6dd;
//    width: 1920px;
//    height: 1080px;
//    position: absolute;
//    top: 50%;
//    left: 50%;
//    transform:scale(1) translate(-50%, -50%);
//    transform-origin: left top;
//    overflow: hidden;
//}
.screen-box{
    color: #d3d6dd;
    background-size: 100% 100% !important;
    background-image: url("../../assets/img/pageBg.png") !important;
}
.bg {
    //整体页面背景
    width: 100%;
    height: 100%;
    //padding: 16px 16px 0 16px;
    background-size: cover; //背景尺寸
    background-position: center center; //背景位置
    --c: #008CFF;
    color: #acd3ec !important;
    text-shadow: 0 0 10px var(--c)
}
.host-body{
    height: 100%;
}
.topBox{
    height: 10%;
}
//顶部右边装饰效果
.title_left {
    width: 100%;
    height: 50px;
}
//顶部左边装饰效果
.title_right {
    width: 100%;
    height: 50px;
    //margin-top: 18px;
}
//顶部中间装饰效果
.title_center {
    width: 100%;
    height: 50px;
}
//顶部右侧装饰效果
.title_left{
    //margin-top: 18px;
}
//顶部中间文字数据可视化系统
.title_text {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    margin-top: 14px;
    color: #acd3ec !important;
}
//时间日期
.title_time {
    margin-top: 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}
.title_name{
    margin-top: 10px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #acd3ec !important;
}
//主体部分
.mainBox{
    height: 90%;
}
//主体左侧
.main-left{
    height: 320px;
}
//主体中间
.main-center{
    height: 960px;
}
//主体右侧
.main-right{
    height: 320px;
}
.goBack{
    width: 25%;
    font-size: 20px;
    margin-left: 40px;
    display: flex;
    align-items: flex-end;
    img{
        display: flex;
        width: 24px;
        cursor: pointer;
        margin-right: 30px;
    }
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.main-left, .main-right, .main-center {
    position: relative;
    overflow: hidden;

    /* 确保边框组件正确渲染 */
    ::v-deep .dv-border-box-13,
    ::v-deep .dv-border-box-1 {
        width: 100% !important;
        height: 100% !important;

        /* 重置可能干扰的动画 */
        polygon, rect {
            transition: none !important;
            animation: none !important;
        }
    }
}

.main-left {
    height: 310px;
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 0;
    }
}

.main-center {
    height: 950px;
}

.main-right {
    height: 310px;
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 0;
    }
}
</style>